import { snapshot } from 'valtio';
import MembersStore from '../stores/members-store';
import UpdateUserRolesStore from '../stores/update-user-roles-store';
import { ActiveMember, Role } from '../types/members-types';

export const closeUpdateUserRolesModal = (): void => {
  setModalVisibility(false);
};

export const openUpdateUserRolesModal = (): void => {
  setModalVisibility(true);
};

const setModalVisibility = (payload: boolean): void => {
  UpdateUserRolesStore.isModalVisible = payload;
};

export const setSelectedMember = (member: ActiveMember): void => {
  UpdateUserRolesStore.selectedMember = member;
};

export const updateUserRoles = (userId: string, userRoles: Role[]): void => {
  const { activeMembers: members } = snapshot(MembersStore);

  const foundMember = members.find(m => m.user_id === userId);
  if (!foundMember) {
    return;
  }

  const activeMember = { ...foundMember };
  activeMember.roles = userRoles;
  const updatedMembers = members.map(m => {
    return m.user_id !== userId ? m : activeMember;
  });

  MembersStore.activeMembers = updatedMembers;
};
